import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-88527578")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_menu = _resolveComponent("el-menu")

  return (_openBlock(), _createBlock(_component_el_menu, {
    class: "side-bar",
    mode: "vertical",
    "default-active": _ctx.activeItem,
    "background-color": "rgb(251,251,251)",
    "text-color": "#8f98a7",
    "active-text-color": "#287cbb",
    "unique-opened": "",
    router: "",
    onSelect: _ctx.selectItem
  }, {
    default: _withId(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
        return (_openBlock(), _createBlock(_component_el_menu_item, {
          key: tag.index,
          index: tag.index
        }, {
          title: _withId(() => [
            _createVNode("i", {
              class: tag.icon
            }, null, 2),
            _createTextVNode(" " + _toDisplayString(tag.title), 1)
          ]),
          _: 2
        }, 1032, ["index"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["default-active", "onSelect"]))
})